import { StudentTahfidz } from "@services/dtos/school.dto";
import { useThemeStore } from "@stores/theme.store";
import { useDetailState } from "@utils/detail_state";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect } from "react";

const jenisBadge: Record<string, { label: string; color: string }> = {
  sabaq: { label: "Sabaq", color: "bg-blue-dark" },
  sabqi: { label: "Sabqi", color: "bg-teal-dark" },
  manzil: { label: "Manzil", color: "bg-orange-dark" },
};

const getJenisBadge = (jenis: string) =>
  jenisBadge[jenis?.toLowerCase()] ?? {
    label: jenis ?? "-",
    color: "bg-blue-dark",
  };

const absenBadge: Record<string, { label: string; color: string }> = {
  hadir: { label: "HADIR", color: "bg-blue-dark" },
  sakit: { label: "SAKIT", color: "bg-red-dark" },
  izin: { label: "IZIN", color: "bg-blue-dark" },
  ijin: { label: "IZIN", color: "bg-blue-dark" },
  alpa: { label: "ALPHA", color: "bg-magenta-dark" },
  alpha: { label: "ALPHA", color: "bg-magenta-dark" },
};

const getAbsenBadge = (absen: string) =>
  absenBadge[absen?.toLowerCase()] ?? {
    label: absen?.toUpperCase() ?? "-",
    color: "bg-blue-dark",
  };

export const StudentTahfidzDetailPage = () => {
  const state = useDetailState<StudentTahfidz>(
    linkPage.SCHOOL_STUDENT_TAHFIDZ
  );
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Tahfidz Santri",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Tahfidz Santri", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  if (!state) return null;

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Tahfidz</div>
        <div className="color-theme mb-3">
          {moment(state.tanggal ?? Date.now()).format(
            "dddd, DD MMMM YYYY | HH:mm"
          )}
        </div>
        <div className="color-highlight">Jenis Setoran</div>
        <div className="color-theme mb-3">
          <span
            className={`badge ${
              getJenisBadge(state.jenis).color
            } color-white font-10 tw-py-1 px-2 rounded-2`}
          >
            {getJenisBadge(state.jenis).label}
          </span>
        </div>
        <div className="color-highlight">Kehadiran</div>
        <div className="color-theme mb-3">
          <span
            className={`badge ${
              getAbsenBadge(state.absen).color
            } color-white font-10 tw-py-1 px-2 rounded-2`}
          >
            {getAbsenBadge(state.absen).label}
          </span>
        </div>
        <div className="color-highlight">Surat</div>
        <div className="color-theme mb-3">{state.surat ?? "-"}</div>
        <div className="color-highlight">Ayat</div>
        <div className="color-theme mb-3">
          {state.ayatMulai ?? "-"} - {state.ayatSelesai ?? "-"}
        </div>
        <div className="color-highlight">Juz</div>
        <div className="color-theme mb-3">{state.juz ?? "-"}</div>
        {(state.baris ?? 0) > 0 && (
          <>
            <div className="color-highlight">Baris</div>
            <div className="color-theme mb-3">{state.baris} Baris</div>
          </>
        )}
        <div className="color-highlight">Nilai</div>
        <div className="color-theme mb-3">{state.nilai ?? "-"}</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state.catatan ?? "-"}</div>
        <div className="color-highlight">Keterangan</div>
        <div className="color-theme mb-3">{state.keterangan ?? "-"}</div>
      </div>
    </div>
  );
};
